import { useEffect, useState } from 'react';
import { Control, FieldErrors, UseFormSetValue } from 'react-hook-form';
import FileDropZoneInput from './FileDropzoneInput';
import FileList from './FileList';

import * as Styled from './styled';

const dedupeFiles = (files: File[]) => {
  return files.reduce((filtered: File[] = [], item) => {
    if (!filtered.some((filteredItem) => JSON.stringify(filteredItem) == JSON.stringify(item))) filtered.push(item);
    return filtered;
  }, []);
};

const FileUploader: React.FC<{
  control: Control<any>;
  errors: FieldErrors<any>;
  setValue: UseFormSetValue<any>;
  maxFiles?: number;
  note?: React.ReactNode;
}> = ({ control, errors, setValue, maxFiles, note }) => {
  const [myFiles, setFiles] = useState<File[]>([]);

  const addFiles = (files: File[]) => {
    setFiles(dedupeFiles(myFiles.concat(files)));
  };

  const removeFile = (file: File) => {
    setFiles(myFiles.filter((f) => f.name !== file.name));
  };

  useEffect(() => {
    setValue('file', myFiles as unknown as File[], {});
  }, [setValue, myFiles]);

  return (
    <Styled.FileUploader>
      <FileDropZoneInput control={control} maxFiles={maxFiles} onDrop={addFiles} error={errors.file} note={note} />
      <div>
        <FileList files={myFiles} removeFile={removeFile} />
      </div>
    </Styled.FileUploader>
  );
};

export default FileUploader;
